import { get, post } from '../../ReaderlyHttpClient';
import { 
  Item 
} from '../Data'; // <-- Ймовірно, це ваш старий інтерфейс для списку (не видаляємо, якщо ще потрібен)
import { 
  BOOKS_SERVICE_URLS, 
  GetItemsRequestData, 
  BookResponseData 
} from './Data';

class ItemsService {
  // No try/catch here: a caller applying filters in quick succession needs to tell an
  // aborted/superseded request apart from a real failure, which a swallowed error can't do.
  async GetItems(data: GetItemsRequestData, signal?: AbortSignal): Promise<Item[]> {
    return post<Item[], GetItemsRequestData>(
      BOOKS_SERVICE_URLS.GET_BOOKS,
      data,
      undefined,
      { signal }
    );
  }

  async GetItemById(id: number): Promise<BookResponseData | null> {
    try {
      const response = await get<BookResponseData>(
        BOOKS_SERVICE_URLS.GET_BOOK_BY_ID + id
      );
      return response;
    } catch (error) {
      console.log('Error Get book by id ' + error);
      return null;
    }
  }
}

const booksServiceInstance = new ItemsService();
export default booksServiceInstance;
